export default __webpack_public_path__ + "static/platform-da4b8d968c50c3c7f0ebaf8ba37bcd0c.png";